module.exports = __webpack_public_path__ + "static/media/IMFeDPrm28P.9d6bb140.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/IMFeDPrm28P.ttf
// module id = 3146
// module chunks = 71